import $ from 'jquery';
import {is_function} from '../../../Helpers/js';
import {Confirmation} from './confirmation';

$.fn.lpConfirmYesNo = function (event, onYes, onNo) {
  return $(this).lpConfirmOn(event, 'yesno', onYes, onNo);
};

$.fn.lpConfirmDeletion = function (event, onDelete, onCancel) {
  return $(this).lpConfirmOn(event, 'delete', onDelete, onCancel);
};

$.fn.lpConfirmTerminate = function (event, onTerminate, onCancel) {
  return $(this).lpConfirmOn(event, 'terminate', onTerminate, onCancel);
};

$.fn.lpConfirmNotification = function (event, onNotify, onCancel) {
  return $(this).lpConfirmOn(event, 'notify', onNotify, onCancel);
};

$.fn.lpConfirmOn = function (event, type, onYes, onNo) {
  var $items = this;

  if (event == 'click') {
    $items.on('click', function (e) {
      e.stopPropagation();
      return $(this).lpConfirm(type, onYes, onNo);
    });
  } else if (event == 'check') {
    $items.on('change', function () {
      var $radio = $(this);
      if ($radio.is(':checked')) {
        $(this).lpConfirm(type, onYes, function () {
          $(this).prop('checked', false);
          if (is_function(onNo)) {
            onNo.call(this);
          }
        });
      }
    });
  } else if (event == 'uncheck') {
    $items.on('change', function () {
      var $radio = $(this);
      if (!$radio.is(':checked')) {
        $(this).lpConfirm(type, onYes, function () {
          $(this).prop('checked', 'checked');
          if (is_function(onNo)) {
            onNo.call(this);
          }
        });
      }
    });
  } else {
    return $(this).lpConfirm(type, onYes, onNo);
  }

  return this;
};

$.fn.lpConfirm = function (type, onYes, onNo) {
  var $item = $(this);
  var yes = function () {
    return is_function(onYes) ? onYes.call($item.get(0)) : true;
  };
  var no = function () {
    return is_function(onNo) ? onNo.call($item.get(0)) : true;
  };
  Confirmation.confirm(type, $item.data('confirm-title'), $item.data('confirm-text'), yes, no);

  return this;
};
